<div class="p-10" *ngIf="selectionService.dataSource.data.length === 0 && !selectionService.isLoading">
    <p>No se encontraron registros</p>
</div>

<div class="p-10 flex-expandir" *ngIf="selectionService.dataSource.data.length > 0 && !selectionService.isLoading">
    <div class="inner-card p-b-10 ">
        <div class="table-header-row">

            <mat-paginator [pageIndex]="selectionService.paginationProps.pageIndex"
                [length]="selectionService.paginationProps.length"
                [pageSize]="selectionService.paginationProps.pageSize" [pageSizeOptions]="[10, 50, 100]"
                (page)="getLeaves($event)">
            </mat-paginator>

            <button mat-icon-button [matMenuTriggerFor]="tableColumnMenu" class="except table-toggle-button">
                <mat-icon class="except">table_chart</mat-icon>
            </button>

            <mat-menu #tableColumnMenu="matMenu" class="except">
                <div class="table-column-toggle-menu" (click)="$event.stopPropagation();">
                    <mat-checkbox *ngFor="let cd of displayedColumns | listFilter: 'ISPERMIT': true; let i = index"
                        (change)="toggleDisplayColumn(cd.column, $event.checked)" [checked]="cd.show"
                        [hidden]="cd.disabled">
                        {{cd.name}}</mat-checkbox>
                </div>
            </mat-menu>

        </div>
        <div class="list-tbl-view scroll-selection flex-expandir">
            <table mat-table [dataSource]="selectionService.dataSource" class="mat-elevation-z8 " #leaveSelection
                id="selection-leave">
                <caption></caption>

                <ng-container matColumnDef="action" class="except">
                    <th id="actions" mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let leave" class="except">

                        <button *ngIf="leave.bloq === null" aria-haspopup="true"
                            class="navbar-toggle-button mat-icon-button icn-person except"
                            (click)="selectionService.GoToEmployee(leave.trabajadorId, leave.bajaId)">
                            <span class="mat-button-wrapper except">
                                <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img"
                                    aria-hidden="true">
                                    person </mat-icon>
                            </span>
                            <div class="mat-button-ripple mat-ripple mat-button-ripple-round except" matripple=""
                                ng-reflect-centered="true">
                            </div>
                            <div class="mat-button-focus-overlay except"></div>
                        </button>

                        <button
                            *ngIf="leave.fAlta === null 
              && (selectionService.selectionPermissions.HasMarcaView || selectionService.selectionPermissions.HasMarcaExternalView) "
                            mat-icon-button [matMenuTriggerFor]="appMenu" class="except">
                            <mat-icon class="except">more_vert</mat-icon>
                        </button>

                        <mat-menu #appMenu="matMenu" class="except">
                            <h5 class="p-0-10 mb-4 mt-4">Marcas</h5>
                            <mat-divider></mat-divider>
                            <div class="table-column-toggle-menu">
                                <mat-checkbox class="no-check"
                                    *ngFor="let marca of marcaOptionList | listFilter: 'ISPERMIT': true; let i = index"
                                    (change)="toggleMarca(leave, marca, $event.checked)"
                                    [checked]="leave.marcas !== null && leave.marcas.includes(marca.label)">
                                    <span [class]="marca.className">{{marca.label}}</span> {{marca.text}}
                                </mat-checkbox>
                            </div>
                        </mat-menu>

                    </td>
                </ng-container>

                <ng-container matColumnDef="marcas">
                    <th id="marcas" mat-header-cell *matHeaderCellDef> Marcas </th>
                    <td mat-cell *matCellDef="let leave">
                        <span *ngIf="selectionService.selectionPermissions.HasMarcaView">
                            <span matTooltip="Marca de Empresa"
                                *ngIf="leave.marcas !== null && leave.marcas.includes('E')" class="lbl3">E</span>
                            <span matTooltip="Marca de Médico"
                                *ngIf="leave.marcas !== null && leave.marcas.includes('M')" class="lbl4">M</span>
                            <span matTooltip="Marca de Coordinador"
                                *ngIf="leave.marcas !== null && leave.marcas.includes('C')" class="lbl2">C</span>
                            <span matTooltip="Marca de Mutua"
                                *ngIf="leave.marcas !== null && leave.marcas.includes('U')" class="lbl8">U</span>
                            <span matTooltip="Marca de Diagnóstico"
                                *ngIf="leave.marcas !== null && leave.marcas.includes('D')" class="lbl7">D</span>
                            <span matTooltip="Marca de Zona" *ngIf="leave.marcas !== null && leave.marcas.includes('Z')"
                                class="lbl7">Z</span>
                            <span matTooltip="Marca de Simulación" *ngIf="leave.marcas !== null && leave.marcas.includes('S')"
                            class="lbl7">S</span>
                            <span matTooltip="Marca de Salud Mental" *ngIf="leave.marcas !== null && leave.marcas.includes('L')"
                            class="lbl7">L</span>
                        </span>
                        <span *ngIf="selectionService.selectionPermissions.HasMarcaExternalView">
                            <span matTooltip="Marca externa" *ngIf="leave.marcas !== null && leave.marcas.includes('X')"
                                class="lbl7">X</span>
                        </span>
                        <span *ngIf="selectionService.selectionPermissions.HasUrgentPositionMark">
                            <span matTooltip="Puesto urgente" *ngIf="leave.puestoUrgente === 'S'"
                                class="lbl6">URG</span>
                        </span>
                        <span *ngIf="selectionService.selectionPermissions.HasEmbarazada">
                            <span matTooltip="Embarazada" *ngIf="leave.embarazada === 'S'" class="lbl6">EMB</span>
                        </span>
                        <span *ngIf="selectionService.selectionPermissions.HasAbsentista">
                            <span matTooltip="Absentista" *ngIf="leave.absentista === 'S'" class="lbl9">                            
                                <span class="fa fa-hand-stop-o icon-red"></span>                            
                            </span>
                        </span>
                        <span >
                            <span matTooltip="Prioritaria" *ngIf="leave.prioritaria === 'S'" class="lbl9">
                                <span class="fa fa-star icon-red"></span>
                            </span>
                        </span>
                        <span >
                            <span matTooltip="Inspección" *ngIf="leave.ifPresentacion !== null" class="lbl6">INSP</span>
                        </span>

                        <span matTooltip="No visitar" *ngIf="leave.noVisitar === 'S'" class="lbl6">NO</span>
                        <span matTooltip="Recaída" *ngIf="leave.recaida === 'S'" class="lbl6">Recaida</span>

                        <span *ngIf="leave.riesgosPsicosociales === 'ENTORNO EXTRALABORAL' || leave.riesgosPsicosociales == 'ENTORNO LABORAL'" >
                            <span matTooltip="Riesgos psicosociales" class="lbl9">
                                <span class="icon-red">&#968;</span>
                            </span>
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="empresa">
                    <th id="empresa" mat-header-cell *matHeaderCellDef> Empresa </th>
                    <td mat-cell *matCellDef="let leave">
                        <div class="overflow-text">{{leave.empresa | titlecase}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="nivel1">
                    <th id="nivel1" mat-header-cell *matHeaderCellDef> Nivel 1 </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.nivel1}} </td>
                </ng-container>

                <ng-container matColumnDef="nivel2">
                    <th id="nivel2" mat-header-cell *matHeaderCellDef> Nivel 2</th>
                    <td mat-cell *matCellDef="let leave"> {{leave.nivel2}} </td>
                </ng-container>

                <ng-container matColumnDef="nivel3">
                    <th id="nivel3" mat-header-cell *matHeaderCellDef> Nivel 3</th>
                    <td mat-cell *matCellDef="let leave"> {{leave.nivel3}} </td>
                </ng-container>

                <ng-container matColumnDef="nivel4">
                    <th id="nivel4" mat-header-cell *matHeaderCellDef> Nivel 4</th>
                    <td mat-cell *matCellDef="let leave"> {{leave.nivel4}} </td>
                </ng-container>

                <ng-container matColumnDef="nivel5">
                    <th id="nivel5" mat-header-cell *matHeaderCellDef> Nivel 5</th>
                    <td mat-cell *matCellDef="let leave"> {{leave.nivel5}} </td>
                </ng-container>
                
                <ng-container matColumnDef="referencia">
                    <th id="referencia" mat-header-cell *matHeaderCellDef> Referencia </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.referencia | titlecase}} </td>
                </ng-container>

                <ng-container matColumnDef="nif">
                    <th id="nif" mat-header-cell *matHeaderCellDef> NIF </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.nif | titlecase}} </td>
                </ng-container>

                <ng-container matColumnDef="trabajador">
                    <th id="trabajador" mat-header-cell *matHeaderCellDef> Trabajador </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.trabajador | titlecase}} </td>
                </ng-container>

                <ng-container matColumnDef="edad">
                    <th id="edad" mat-header-cell *matHeaderCellDef> Edad </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.edad}} </td>
                </ng-container>

                <ng-container matColumnDef="puesto">
                    <th id="edad" mat-header-cell *matHeaderCellDef> Puesto </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.puesto}} </td>
                </ng-container>

                <ng-container matColumnDef="gender">
                    <th id="gender" mat-header-cell *matHeaderCellDef> Género </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.gender | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="phones">
                    <th id="phones" mat-header-cell *matHeaderCellDef> Teléfonos </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.phones}} </td>
                </ng-container>
                <ng-container matColumnDef="direccion">
                    <th id="direccion" mat-header-cell *matHeaderCellDef> Dirección </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.direccion}} </td>
                </ng-container>
                <ng-container matColumnDef="poblacion">
                    <th id="poblacion" mat-header-cell *matHeaderCellDef> Población </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.poblacion}} </td>
                </ng-container>
                <ng-container matColumnDef="provincia">
                    <th id="provincia" mat-header-cell *matHeaderCellDef> Provincia </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.provincia}} </td>
                </ng-container>
                <ng-container matColumnDef="cp">
                    <th id="cp" mat-header-cell *matHeaderCellDef> CP </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.cp}} </td>
                </ng-container>

                <ng-container matColumnDef="fAntiguedad">
                    <th id="fAntiguedad" mat-header-cell *matHeaderCellDef> F. Antigüedad </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.fAntiguedad | date:"dd/MM/yyyy"}} </td>
                </ng-container>

                <ng-container matColumnDef="fFinContrato">
                    <th id="fFinContrato" mat-header-cell *matHeaderCellDef> F. Fin Contrato </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.fFinContrato | date:"dd/MM/yyyy"}} </td>
                </ng-container>

                <ng-container matColumnDef="jornada">
                    <th id="jornada" mat-header-cell *matHeaderCellDef> % Jornada </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.jornada}} </td>
                </ng-container>

                <ng-container matColumnDef="tipo">
                    <th id="tipo" mat-header-cell *matHeaderCellDef> Tipo </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.tipo}} </td>
                </ng-container>

                <ng-container matColumnDef="fBaja">
                    <th id="fBaja" mat-header-cell *matHeaderCellDef> F. Baja </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.fBaja | date:"dd/MM/yyyy"}} </td>
                </ng-container>

                <ng-container matColumnDef="leaveRef">
                    <th id="leaveRef" mat-header-cell *matHeaderCellDef> Referencia de Baja </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.leaveRef}} </td>
                </ng-container>

                <ng-container matColumnDef="comEmpresa">
                    <th id="comEmpresa" mat-header-cell *matHeaderCellDef> Comentario de empresa </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.comentarioParaEmpresa}} </td>
                </ng-container>

                <ng-container matColumnDef="consentimiento">
                    <th id="consentimiento" mat-header-cell *matHeaderCellDef> LOPD </th>
                    <td mat-cell *matCellDef="let leave">
                        <ng-container [ngSwitch]="leave.consentimiento">
                        <span *ngSwitchCase="'E'">Consentimiento entregado</span>
                        <span *ngSwitchCase="'G'">Consentimiento grabado</span>
                        <span *ngSwitchCase="'S'">Con consentimiento</span>
                        <span *ngSwitchDefault>Sin consentimiento</span>
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fAlta">
                    <th id="fAlta" mat-header-cell *matHeaderCellDef> F. Alta </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.fAlta | date:"dd/MM/yyyy"}} </td>
                </ng-container>

                <ng-container matColumnDef="dias">
                    <th id="dias" mat-header-cell *matHeaderCellDef> Días </th>
                    <td mat-cell *matCellDef="let leave">
                        <span *ngIf="leave.dias > 180"><span class="fa fa-circle icon-red"></span></span>
                        <span *ngIf="leave.dias > 90 && leave.dias < 180"><span
                                class="fa fa-circle icon-orange"></span></span>
                        <span *ngIf="leave.dias > 30 && leave.dias < 90"><span
                                class="fa fa-circle icon-yellow"></span></span>
                        <span *ngIf="leave.dias <= 30 && leave.dias > 0"><span class="fa fa-circle-thin"></span></span>
                        {{leave.dias}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="diasPeriodo">
                    <th id="diasPeriodo" mat-header-cell *matHeaderCellDef> Días en periodo </th>
                    <td mat-cell *matCellDef="let leave">
                        {{leave.diasPeriodo}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="avisoBaja">
                    <th id="avisoBaja" mat-header-cell *matHeaderCellDef> Aviso Baja </th>
                    <td mat-cell *matCellDef="let leave">
                        <span *ngIf="leave.avisoBaja >=  leave.fAlta"><span class="fa fa-circle icon-red"></span></span>
                        {{leave.avisoBaja | date:"dd/MM/yyyy"}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="diasAvisoBaja">
                    <th id="diasAvisoBaja" mat-header-cell *matHeaderCellDef> Días Aviso B. </th>
                    <td mat-cell *matCellDef="let leave">
                        <span *ngIf="leave.diasAvisoBaja > 3"><span class="fa fa-circle icon-red"></span></span>
                        {{leave.diasAvisoBaja}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="avisoAlta">
                    <th id="avisoAlta" mat-header-cell *matHeaderCellDef> Aviso Alta </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.avisoAlta | date:"dd/MM/yyyy" }} </td>
                </ng-container>

                <ng-container matColumnDef="diasAvisoAlta">
                    <th id="diasAvisoAlta" mat-header-cell *matHeaderCellDef> Días Aviso A. </th>
                    <td mat-cell *matCellDef="let leave">
                        <span *ngIf="leave.diasAvisoAlta > 3"><span class="fa fa-circle icon-red"></span></span>
                        {{leave.diasAvisoAlta}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="medico">
                    <th id="medico" mat-header-cell *matHeaderCellDef> Médico </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.medico}} </td>
                </ng-container>

                <ng-container matColumnDef="nj">
                    <th id="nj" mat-header-cell *matHeaderCellDef> NJ </th>
                    <td mat-cell *matCellDef="let leave">
                        <span *ngIf="leave.nj === 'NJ'" class="lbl1">{{leave.nj}}</span>
                        <span *ngIf="leave.nj === 'JA'" class="lbl8">{{leave.nj}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fechaNJ">
                    <th id="fechaNJ" mat-header-cell *matHeaderCellDef> Fecha NJ </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.fechaNJ | date:"dd/MM/yyyy"}} </td>
                </ng-container>

                <ng-container matColumnDef="diasNJ">
                    <th id="diasNJ" mat-header-cell *matHeaderCellDef> Días NJ </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.diasNJ}} </td>
                </ng-container>

                <ng-container matColumnDef="fpa">
                    <th id="fpa" mat-header-cell *matHeaderCellDef> FPA </th>
                    <td mat-cell *matCellDef="let leave"> {{ leave.fpa | date:"dd/MM/yyyy" }} </td>
                </ng-container>

                <ng-container matColumnDef="diasPrevistos">
                    <th id="diasPrevistos" mat-header-cell *matHeaderCellDef> Días previstos </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.diasPrevistos}} </td>
                </ng-container>

                <ng-container matColumnDef="pes">
                    <th id="pes" mat-header-cell *matHeaderCellDef> PES </th>
                    <td mat-cell *matCellDef="let leave">
                        <span *ngIf="leave.pes === 'S'" class="lbl1">{{leave.pes}}</span>

                    </td>
                </ng-container>

                <ng-container matColumnDef="codDiagnostico">
                    <th id="codDiagnostico" mat-header-cell *matHeaderCellDef> Código D. </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.codDiagnostico}} </td>
                </ng-container>

                <ng-container matColumnDef="diagnostico">
                    <th id="diagnostico" mat-header-cell *matHeaderCellDef> Diagnóstico </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.diagnostico | titlecase}} </td>
                </ng-container>

                <ng-container matColumnDef="grupoDiagnostico">
                    <th id="grupoDiagnostico" mat-header-cell *matHeaderCellDef> Grupo D. </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.grupoDiagnostico | titlecase}} </td>
                </ng-container>
                
                <ng-container matColumnDef="ifpresentacion">
                    <th id="ifpresentacion" mat-header-cell *matHeaderCellDef>F. Pres. Insp. </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.ifPresentacion | date:"dd/MM/yyyy"}} </td>
                </ng-container>
                <ng-container matColumnDef="imotivo">
                    <th id="imotivo" mat-header-cell *matHeaderCellDef> Motivo Insp. </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.iMotivo | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="ifvisita">
                    <th id="ifvisita" mat-header-cell *matHeaderCellDef>F. Visita Insp. </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.ifVisita | date:"dd/MM/yyyy"}} </td>
                </ng-container>
                <ng-container matColumnDef="ifrespuesta">
                    <th id="ifrespuesta" mat-header-cell *matHeaderCellDef>F. Resp. Insp. </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.ifRespuesta | date:"dd/MM/yyyy"}} </td>
                </ng-container>
                <ng-container matColumnDef="irespuesta">
                    <th id="irespuesta" mat-header-cell *matHeaderCellDef> Respuesta Insp. </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.iRespuesta | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="freclamacionInsp">
                    <th id="freclamacionInsp" mat-header-cell *matHeaderCellDef> F. Recl. Insp. </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.fReclamacionInsp | date:"dd/MM/yyyy"}} </td>
                </ng-container>
                <ng-container matColumnDef="obs">
                    <th id="obs" mat-header-cell *matHeaderCellDef> Obs. Insp. </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.obs | titlecase}} </td>
                </ng-container>
                

                <ng-container matColumnDef="atributos">
                    <th id="atributos" mat-header-cell *matHeaderCellDef> Atributos </th>
                    <td mat-cell *matCellDef="let leave" class="attributos-td">
                        <span *ngIf="leave.tAttr1 != null && leave.tAttr1 != ''">{{leave.tAttr1 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr2 != null && leave.tAttr2 != ''">{{leave.tAttr2 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr3 != null && leave.tAttr3 != ''">{{leave.tAttr3 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr4 != null && leave.tAttr4 != ''">{{leave.tAttr4 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr5 != null && leave.tAttr5 != ''">{{leave.tAttr5 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr6 != null && leave.tAttr6 != ''">{{leave.tAttr6 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr7 != null && leave.tAttr7 != ''">{{leave.tAttr7 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr8 != null && leave.tAttr8 != ''">{{leave.tAttr8 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr9 != null && leave.tAttr9 != ''">{{leave.tAttr9 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr10 != null && leave.tAttr10 != ''">{{leave.tAttr10 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr11 != null && leave.tAttr11 != ''">{{leave.tAttr11 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr12 != null && leave.tAttr12 != ''">{{leave.tAttr12 | titlecase}} ||</span>
                        <span *ngIf="(leave.tAttr1 === null || leave.tAttr1 === '') && 
              (leave.tAttr2 === null || leave.tAttr2 === '') && 
              (leave.tAttr3 === null || leave.tAttr3 === '') &&
              (leave.tAttr4 === null || leave.tAttr4 === '') &&
              (leave.tAttr5 === null || leave.tAttr5 === '') &&
              (leave.tAttr6 === null || leave.tAttr6 === '') &&
              (leave.tAttr7 === null || leave.tAttr7 === '') &&
              (leave.tAttr8 === null || leave.tAttr8 === '') &&
              (leave.tAttr9 === null || leave.tAttr9 === '') &&
              (leave.tAttr10 === null || leave.tAttr10 === '') &&
              (leave.tAttr11 === null || leave.tAttr11 === '') &&
              (leave.tAttr12 === null || leave.tAttr12 === '')">
                            Sin Atributos
                        </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="ultimaactuacion">
                    <th id="ultimaactuacion" mat-header-cell *matHeaderCellDef> Ultima Actuacion </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.fecha | date:"dd/MM/yyyy"}} - {{leave.tipoActuacion | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="proximatarea">
                    <th id="proximatarea" mat-header-cell *matHeaderCellDef> Proxima Tarea </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.fechaTarea | date:"dd/MM/yyyy"}} - {{leave.tarea | titlecase}} - {{leave.autorTarea | titlecase}}</td>
                </ng-container>

                <ng-container matColumnDef="tAttr1">
                    <th id="tAttr1" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[0].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr1 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr2">
                    <th id="tAttr2" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[1].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr2 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr3">
                    <th id="tAttr3" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[2].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr3 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr4">
                    <th id="tAttr4" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[3].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr4 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr5">
                    <th id="tAttr5" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[4].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr5 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr6">
                    <th id="tAttr6" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[5].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr6 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr7">
                    <th id="tAttr7" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[6].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr7 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr8">
                    <th id="tAttr8" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[7].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr8 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr9">
                    <th id="tAttr9" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[8].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr9 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr10">
                    <th id="tAttr10" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[9].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr10 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr11">
                    <th id="tAttr11" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[10].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr11 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr12">
                    <th id="tAttr12" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[11].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr12 | titlecase}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>
                <tr mat-row *matRowDef="let leave; columns: getDisplayedColumns();"
                    [ngClass]="{'selection-highlight-row': selectedRowIndex == leave.bajaId && selectionService.isShowLeavePanel}"
                    (click)="getLeaveRecord(leave, $event)">
                </tr>
            </table>
        </div>
    </div>
</div>